export const richTextMarkdownContentMock = `
# Desenvolvimento e seus paradigmas

Historicamente, a partir de tres visoes paradigmaticas, o conceito de desenvolvimento vem sendo entendido como crescimento economico, satisfacao das necessidades basicas e, mais modernamente, como elemento de sustentabilidade socioambiental.

Assim, diversas nocoes incluem o Brasil, pautam-se em perspectivas do desenvolvimento diferentes ao longo da sua historia.

Para ficar mais facil de entender, vamos fazer um exercicio. Observe a figura a seguir:

<p align="center">
  <img src="https://images.unsplash.com/photo-1466611653911-95081537e5b7?q=80&w=1200" alt="Planta nas maos" />
</p>

<p align="center">
  <em>Exemplo de desenvolvimento sustentavel</em>
</p>

Agora veja o video abaixo:

<p align="center">
  <iframe
    width="560"
    height="315"
    src="https://www.youtube.com/embed/aqz-KE-bpKQ"
    frameborder="0"
    allowfullscreen>
  </iframe>
</p>

Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.

## Objetivos de Desenvolvimento Sustentavel

<p align="center">
  <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Sustainable_Development_Goals.png/800px-Sustainable_Development_Goals.png" alt="ODS" />
</p>

Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.

### Lista de pontos importantes

- Desenvolvimento economico
- Sustentabilidade ambiental
- Inclusao social

### Tabela de exemplo

| Coluna 1 | Coluna 2 | Coluna 3 | Coluna 4 | Coluna 5 | Coluna 6 |
|----------|----------|----------|----------|----------|----------|
| 100      | 100      | 100      | 100      | 100      | 100      |
| 200      | 200      | 200      | 200      | 200      | 200      |
| 300      | 300      | 300      | 300      | 300      | 300      |
| 400      | 400      | 400      | 400      | 400      | 400      |

### Checklist para testes

- [x] Conteudo carregado
- [x] Tabela renderizada
- [ ] Video responsivo
- [ ] Validar links externos

### Bloco de citacao

> Desenvolvimento sustentavel depende de equilibrio entre economia, sociedade e meio ambiente.

### Emojis

Teste com unicode: 😀 🚀 ✅

Teste com shortcode: :rocket: :white_check_mark: :smile:

### Codigo

Codigo inline: \`const progresso = 100;\`

\`\`\`typescript
interface Indicador {
  nome: string;
  valor: number;
}

const indicadores: Indicador[] = [
  { nome: 'Eficiencia', valor: 92 },
  { nome: 'Satisfacao', valor: 88 },
];

console.table(indicadores);
\`\`\`

### Formulas matematicas

Formula inline: $E = mc^2$

Formula em bloco:

$$
\int_{0}^{1} x^2\,dx = \frac{1}{3}
$$

$$
\frac{-b \pm \sqrt{b^2 - 4ac}}{2a}
$$

### Textos com cores diferentes

<span style="color:#22c55e;">Texto em verde para teste de cor.</span>

<span style="color:#f59e0b;">Texto em laranja para destaque.</span>

<span style="color:#60a5fa;">Texto em azul para links e referencias.</span>

### Texto grifado

<mark>Este trecho esta grifado para validar highlight no rich text.</mark>

### Listas adicionais

Lista ordenada:

1. Primeiro item de teste
2. Segundo item de teste
3. Terceiro item de teste

Lista aninhada:

- Nivel 1
  - Nivel 2
    - Nivel 3

### Links

[Acessar site da ONU](https://www.un.org/sustainabledevelopment/)

[Documentacao do Markdown](https://www.markdownguide.org/)

Link puro: https://katex.org/

**Conclusao:** O desenvolvimento moderno exige equilibrio entre crescimento economico e preservacao ambiental.
`;
